<template>
  <div class="gray-view">
    <div class="my-credit-card">
      <div class="my-info">
        <p>{{ t('my_subscription') }}</p>
        <span class="badge primary-bg">{{ subscriptionStore.userPlan }}</span>
      </div>

      <div class="remain-cd">
        <img :src="getAssetImageUrl('common/icons/credit-icon.svg')" alt="" />
        <strong>{{ formatNumberWithComma(subscriptionStore.currentCredits) }}</strong>
      </div>

      <!-- TODO: 인앱 결제시, 구현 예정
      <div class="app-btn-wrap">
        <RouterLink to="/mobile/card" class="gray-btn m-btn" aria-label="">
          <span>카드 관리하기</span>
        </RouterLink>
        <RouterLink to="/app/creditbuy" class="gray-btn m-btn" aria-label="">
          <span>크레딧 구매하기</span>
        </RouterLink>
      </div> 
      -->
    </div>

    <!-- TODO: 인앱 결제시, 구현 예정
    <div class="auto-switch-wrap">
      <p>크레딧 자동 충전</p>
      <div class="switch-btn">
        <input type="checkbox" id="switch01" class="switch-input" />
        <label for="switch01" class="switch"></label>
      </div>
    </div> 
    -->
  </div>

  <div class="usage-history">
    <h1 class="app-page-tit">{{ t('credit_history') }}</h1>
    <ButtonFilterList :filter-list="CREDIT_TYPE_FILTERS" :active-value="searchType" @change="handleFilterClick" />

    <template v-if="creditList.length > 0">
      <div v-for="{ date, items } in creditList" :key="date" class="day-item">
        <span class="date">{{ date }}</span>
        <ul class="inr-list">
          <li v-for="item in items" :key="item.eventedAt">
            <div class="row top">
              <span class="time">{{ item.displayTime }}</span>
              <span>{{ t(`${item.displayType}`) }}</span>
            </div>

            <div class="row bottom">
              <span v-if="item.type === 'CHARGE'">{{ t('add_credit') }}</span>
              <span v-if="item.type === 'USAGE'">{{ t(`label_${item.chatType.toLowerCase()}`) }}</span>
              <strong class="amount" :class="{ plus: item.type === 'CHARGE' }">
                {{ item.creditSign }}{{ formatNumberWithComma(item.amount) }} {{ t('credit') }}
              </strong>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="pagination.hasMore" class="view-btn-wrap">
        <button class="all-view-btn" @click="showMore">
          <span>{{ t('more') }}</span>
          <IconArrow class="icon" />
        </button>
      </div>
    </template>

    <div v-else class="no-data pd-vertical-7 no-data-flex">
      <div class="icon-area">
        <img :src="getAssetImageUrl('app/status/no-data.svg')" alt="" />
      </div>
      <span>{{ t('no_records') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonFilterList from '@/components/domains/mobile/common/ButtonFilterList.vue';
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';
import { useCreditList } from '@/composables/domains/mobile/useCreditList';
import { useSubscriptionStore } from '@/stores/subscription';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const { t } = useI18n();

const subscriptionStore = useSubscriptionStore();

const { CREDIT_TYPE_FILTERS, searchType, creditList, setSearchType, fetchCreditList, pagination } = useCreditList();

const handleFilterClick = (filter) => {
  setSearchType(filter);
};

const showMore = () => {
  fetchCreditList(pagination.value.nextOffset);
};

onMounted(() => {
  fetchCreditList();
  setSearchType('ALL');
});
</script>

<style scoped lang="scss">
.gray-view {
  background: $gray10;
  width: calc(100% + 40px);
  position: relative;
  left: -20px;
  padding: $size-xl;

  .my-credit-card {
    background: #fff;
    border-radius: $size-m;
    padding: 1.25rem 1rem;
    .my-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: $size-xs;
      p {
        font-weight: 500;
      }
    }
    .remain-cd {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem 0 1.25rem;
      gap: $size-xs;
      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }
      strong {
        font-weight: 500;
        font-size: 2rem;
      }
    }
    .app-btn-wrap {
      .gray-btn {
        span {
          color: $color-gray-800;
        }
      }
    }
  }

  .auto-switch-wrap {
    margin-top: $size-s;
    background: #fff;
    padding: 0.75rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: $size-m;
    p {
      font-size: $font-size-psmall;
    }
  }
}

.usage-history {
  padding: 2rem 0;
  h1 {
    margin-bottom: 0.75rem;
  }
  .day-item {
    margin-top: 1.5rem;
    .date {
      display: block;
      font-size: $font-size-xxs;
      margin-bottom: 0.5rem;
    }
    .inr-list {
      border-top: 1px solid $color-gray-900;
      li {
        border-bottom: 1px solid $color-gray-40;
        padding: 1rem 0;
        .row {
          display: flex;
          justify-content: space-between;
          &.top {
            margin-bottom: 0.5rem;
            span {
              font-size: $font-size-xxs;
              &.time {
                color: $color-gray-100;
              }
            }
          }
          &.bottom {
            span {
              font-weight: 600;
            }
            .amount {
              font-weight: 600;
              &.plus {
                color: $meeting;
              }
            }
          }
        }
      }
    }
  }
}
.view-btn-wrap {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  .all-view-btn {
    padding: 0.75rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    text-decoration: none;
    span {
      font-size: $font-size-psmall;
      color: $color-gray-500;
      font-weight: 500;
    }
    svg {
      transform: rotate(180deg);
    }
  }
}
</style>
